import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';

interface IconWrapperProps {
  isInputFocused?: boolean;
}

export const IconWrapper = styled(Box).attrs<IconWrapperProps>(
  ({ isInputFocused, theme }) => ({
    justify: 'center',
    height: '100%',
    align: 'center',
    px: '10px',
    color: `secondaryText`,
    borderRight: `1px solid ${
      isInputFocused ? theme.colors.primaryBase : theme.colors.heavyLineOutline
    }`,
  }),
)<IconWrapperProps>``;

export const StyledInputText = styled(InputText)`
  text-indent: 10px;
`;
